import React from 'react';
import { ITableColumn } from './getColumns';
import { camelCaseToTitleCase } from 'utilities/shared/stringMethods/stringMethods';
import { currencyFields, eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import classNames from 'classnames';
import { Currency } from 'ui-toolkit/components/Currency';

export interface IFeeSectionTableColumnHeadersProps {
  columns: ITableColumn[];
  feeSectionTotals?: { [key: string]: number };
}

export const FeeSectionTableColumnHeaders: React.FC<IFeeSectionTableColumnHeadersProps> = ({
  columns,
  feeSectionTotals = {},
}) => {
  return (
    <>
      {columns.map((t, i, l) => (
        <TableHeader key={t.label} index={i} columns={l} feeSectionTotals={feeSectionTotals} />
      ))}
    </>
  );
};

const TableHeader: React.FC<{
  index: number;
  columns: ITableColumn[];
  feeSectionTotals: { [key: string]: number };
}> = ({ index, columns, feeSectionTotals }) => {
  if (columns[index].isVisible === false) {
    return <div></div>;
  }
  // If we are looking at a before closing and the matching 'At Closing' is before it, skip it. We already did this column
  if (matchingColumns(columns[index - 1]?.label, columns[index].label)) {
    return <></>;
  }

  if (matchingColumns(columns[index].label, columns[index + 1]?.label)) {
    const hasRight = !matchingColumns(columns[index + 2]?.label, columns[index + 3]?.label);
    const title = columns[index].label.replace('AtClosing', '');
    const valueKey = title.replace('borrower', 'buyer');
    return (
      <div
        className={classNames(`grid col-span-2 p-4 border-l border-solid border-gray-200`, hasRight ? 'border-r' : '')}
      >
        <div className={'justify-self-end uppercase font-medium'}>{camelCaseToTitleCase(title)}</div>

        <div className={'justify-self-end font-medium text-base'}>
          <Currency value={feeSectionTotals[valueKey] || 0} />
        </div>
        <div className={`grid grid-cols-2 justify-items-end`}>
          <div className={`pr-4`}>At Closing</div>
          <div>Before Closing</div>
        </div>
      </div>
    );
  }
  const isCurrency = currencyFields.includes(columns[index].label as eFeePropertyNames);
  const isBoolean = ['nettedOut'].includes(columns[index].label);
  const justification = isCurrency ? 'justify-self-end' : isBoolean ? 'justify-self-center' : 'justify-self-start';

  return <div className={`${justification} p-4 items-end`}>{camelCaseToTitleCase(columns[index].label)}</div>;
};

const matchingColumns = (first?: string, second?: string) => {
  if (
    first === undefined ||
    second === undefined ||
    !first.endsWith('AtClosing') ||
    !second.endsWith('BeforeClosing')
  ) {
    return false;
  }

  return first.replace('AtClosing', '') === second.replace('BeforeClosing', '');
};
